import axios from 'axios'
import { jobPositionUrl, getHeader } from '../config'

const state = {
  jobPositionList: []
}

const mutations = {
  SET_JOB_POSITION_LIST (state, obj) {
    state.jobPositionList = obj
  }
}

const actions = {
  getJobPositionList: ({ commit }) => {
    axios.get(jobPositionUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_JOB_POSITION_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
